import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from 'components/main-layout/main-layout';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ImgHome from 'assets/img/home.png';
import Image from 'react-bootstrap/Image';
import Header from 'components/header/header';
import { ContainerStyled } from './style';

function Home() {
  return (
    <MainLayout>
      <ContainerStyled>
        <Container>
          <Header />

          <Row>
            <Col md={5}>
              <Image src={ImgHome} fluid />
            </Col>
            <Col md={7}>
              <h3>Aprovação automática +MAISACESSO</h3>
              <p>
                Sua Instituição de Ensino está qualificada para usar a aprovação
                automatizada no convênio com +MAISACESSO.
              </p>
              <p>
                Com a aprovação automática, você pode definir regras na
                concessão do crédito, que aprovarão automaticamente estudantes
                que atenderem aos critérios.
              </p>
              <p>
                Você não possui uma automação criada. <br />
                Que tal criarmos uma?
              </p>
              <Link
                className="btn btn-primary"
                to="/aprovacao-automatica/create"
              >
                Criar aprovação automática
              </Link>
            </Col>
          </Row>
        </Container>
      </ContainerStyled>
    </MainLayout>
  );
}

export default Home;
